module.exports = __webpack_public_path__ + "img/inquery-th.3462df7.png";